import { render, staticRenderFns } from "./DeclarationOfSecurity.vue?vue&type=template&id=7490a048&scoped=true&"
import script from "./DeclarationOfSecurity.vue?vue&type=script&lang=js&"
export * from "./DeclarationOfSecurity.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationOfSecurity.vue?vue&type=style&index=0&id=7490a048&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7490a048",
  null
  
)

export default component.exports